angular.module('bmsApp').factory('SecurityTypeSvc', function ($http, $log, $window, $q, CRUDSvc, SECURITY_TYPE_SVC_API) {

	return {
		options: function (params) {
			return CRUDSvc.get(SECURITY_TYPE_SVC_API.OPTIONS, params);
		}
	}

}).constant('SECURITY_TYPE_SVC_API', {
	OPTIONS: 'api/securityTypes/options'
});